/**
 * Normaliza respostas de listagem da API (GET).
 * Em erro HTTP, api.call devolve o objeto Response do fetch — não um array.
 */
export function parseApiListResponse(response) {
    if (Array.isArray(response)) {
        return { ok: true, data: response };
    }

    if (response && typeof response.status === 'number') {
        if (response.status === 403) {
            return {
                ok: false,
                data: [],
                message:
                    'Não foi possível carregar os dados. Você não tem permissão para acessar este produto no momento. Se o problema persistir, entre em contato com o suporte.',
            };
        }

        if (response.status >= 400) {
            return {
                ok: false,
                data: [],
                message:
                    'Não foi possível carregar os dados. Tente novamente em alguns instantes.',
            };
        }
    }

    return {
        ok: false,
        data: [],
        message:
            'Não foi possível carregar os dados. Tente novamente em alguns instantes.',
    };
}



// WEBPACK FOOTER //
// ./src/utils/apiResponse.js